module.exports = __webpack_public_path__ + "img/Viacor_Claim_pos_silver_RGB.9768a2cf.png";